(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mq-about-journey"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mq-reveal')) {
    customElements.define('mq-reveal', class MqReveal extends HTMLElement {
      connectedCallback() {
        if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) { this.classList.add('is-in'); return; }
        this.io = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) { this.classList.add('is-in'); this.io.disconnect(); }
        }, { threshold: 0.2 });
        this.io.observe(this);
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mq-about-values"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mq-reveal')) {
    customElements.define('mq-reveal', class MqReveal extends HTMLElement {
      connectedCallback() {
        if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) { this.classList.add('is-in'); return; }
        this.io = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) { this.classList.add('is-in'); this.io.disconnect(); }
        }, { threshold: 0.2 });
        this.io.observe(this);
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mq-collection"] && !Shopify.designMode) return;
  try {
    
  if (!window.__mqSortBound) {
    window.__mqSortBound = true;
    document.addEventListener('change', (e) => {
      const select = e.target.closest('[data-mq-sort]');
      if (!select) return;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mq-events"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mq-events')) {
    customElements.define('mq-events', class MqEvents extends HTMLElement {
      connectedCallback() {
        this.counts = Array.from(this.querySelectorAll('[data-ts]'));
        this.days = Array.from(this.querySelectorAll('.mq-ev__day.has-ev'));
        this.update = this.update.bind(this);
        this.update();
        if (this.counts.length) this.timer = setInterval(this.update, 30000);
        this.days.forEach((btn) => btn.addEventListener('click', () => this.filter(btn)));
      }

      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
      }

      update() {
        const now = Date.now();
        this.counts.forEach((el) => {
          const start = parseInt(el.dataset.ts, 10) * 1000;
          const end = parseInt(el.dataset.end, 10) * 1000;
          if (!start) return;
          el.classList.remove('is-soon', 'is-live');
          let text;
          if (now < start) {
            const diff = start - now;
            const d = Math.floor(diff / 86400000);
            const h = Math.floor((diff % 86400000) / 3600000);
            const m = Math.floor((diff % 3600000) / 60000);
            if (d > 0) text = d + 'd ' + h + 'h to go';
            else if (h > 0) text = h + 'h ' + m + 'm to go';
            else text = Math.max(m, 1) + ' min to go';
            if (d === 0) el.classList.add('is-soon');
          } else if (now < end) {
            text = 'Happening now';
            el.classList.add('is-live');
          } else {
            text = 'Ended';
          }
          el.textContent = text;
        });
      }

      filter(btn) {
        const turnOn = btn.getAttribute('aria-pressed') !== 'true';
        this.days.forEach((b) => b.setAttribute('aria-pressed', 'false'));
        const items = this.querySelectorAll('.mq-ev__feat, .mq-ev__row');
        if (!turnOn) {
          items.forEach((i) => i.classList.remove('is-dim'));
          return;
        }
        btn.setAttribute('aria-pressed', 'true');
        const key = btn.dataset.day;
        items.forEach((i) => i.classList.toggle('is-dim', i.dataset.day !== key));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mq-favorites"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mq-tabs')) {
    customElements.define('mq-tabs', class MqTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i, true));
          tab.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            e.preventDefault();
            const n = this.tabs.length;
            const next = (i + (e.key === 'ArrowRight' ? 1 : -1) + n) % n;
            this.select(next, true);
            this.tabs[next].focus();
          });
        });
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.panels.indexOf(e.target.closest('[role="tabpanel"]'));
          if (i > -1) this.select(i, false);
        });
      }

      select(index, animate) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel, i) => {
          const active = i === index;
          if (active && panel.hidden) {
            panel.hidden = false;
            if (animate) {
              panel.classList.remove('is-entering');
              void panel.offsetWidth;
              panel.classList.add('is-entering');
            }
          } else if (!active) {
            panel.hidden = true;
            panel.classList.remove('is-entering');
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mq-flash-campaign"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mq-countdown')) {
    customElements.define('mq-countdown', class MqCountdown extends HTMLElement {
      connectedCallback() {
        this.end = Date.parse(this.dataset.end);
        this.start = this.dataset.start ? Date.parse(this.dataset.start) : NaN;
        this.action = this.dataset.expiredAction || 'hide';
        this.showDays = this.dataset.showDays !== 'false';
        this.design = !!(window.Shopify && window.Shopify.designMode);
        this.wrapper = this.closest('.shopify-section');
        this.root = this.closest('.mq-fbar');
        this.timer = this.querySelector('[data-timer]');
        this.expired = this.querySelector('[data-expired]');
        this.actions = this.querySelector('[data-actions]');
        this.nums = {
          d: this.querySelector('[data-unit="d"]'),
          h: this.querySelector('[data-unit="h"]'),
          m: this.querySelector('[data-unit="m"]'),
          s: this.querySelector('[data-unit="s"]')
        };
        this.querySelectorAll('[data-copy]').forEach((btn) => {
          btn.addEventListener('click', () => this.copy(btn));
        });
        this.tick = this.tick.bind(this);
        this.tick();
        this.interval = setInterval(this.tick, 1000);
      }

      disconnectedCallback() { clearInterval(this.interval); }

      copy(btn) {
        const code = btn.dataset.copy;
        const original = btn.dataset.original || btn.textContent;
        btn.dataset.original = original;
        const done = () => {
          btn.textContent = btn.dataset.copied || 'Copied';
          clearTimeout(this.copyTimer);
          this.copyTimer = setTimeout(() => { btn.textContent = original; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(() => this.fallbackCopy(code, done));
        } else {
          this.fallbackCopy(code, done);
        }
      }

      fallbackCopy(code, done) {
        const input = document.createElement('textarea');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        input.remove();
      }

      hideSection() {
        if (this.design) return;
        if (this.wrapper) this.wrapper.style.display = 'none';
      }

      pad(n) { return n < 10 ? '0' + n : String(n); }

      setNum(key, value) {
        const el = this.nums[key];
        if (!el) return;
        const text = this.pad(value);
        if (el.textContent !== text) el.textContent = text;
      }

      tick() {
        const now = Date.now();
        if (isNaN(this.end)) { this.hideSection(); clearInterval(this.interval); return; }
        if (!isNaN(this.start) && now < this.start) { this.hideSection(); return; }
        if (this.wrapper && !this.design) this.wrapper.style.display = '';

        const diff = Math.max(0, Math.floor((this.end - now) / 1000));
        if (this.showDays) {
          this.setNum('d', Math.floor(diff / 86400));
          this.setNum('h', Math.floor((diff % 86400) / 3600));
        } else {
          this.setNum('h', Math.floor(diff / 3600));
        }
        this.setNum('m', Math.floor((diff % 3600) / 60));
        this.setNum('s', diff % 60);

        if (diff === 0) {
          clearInterval(this.interval);
          if (this.action === 'hide') this.hideSection();
          if (this.root) this.root.classList.add('is-expired');
          if (this.timer) this.timer.hidden = true;
          if (this.expired) this.expired.hidden = false;
          if (this.actions) this.actions.hidden = true;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mq-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mq-footer-accordion')) {
    customElements.define('mq-footer-accordion', class MqFooterAccordion extends HTMLElement {
      connectedCallback() {
        this.mq = window.matchMedia('(max-width: 749px)');
        this.items = Array.from(this.querySelectorAll('[data-acc]'));
        this.items.forEach((item) => {
          const btn = item.querySelector('[data-acc-btn]');
          if (!btn) return;
          btn.addEventListener('click', () => {
            if (!this.mq.matches) return;
            this.toggle(item, !item.classList.contains('is-open'));
          });
        });
        this.onChange = () => this.sync();
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.onChange);
        else if (this.mq.addListener) this.mq.addListener(this.onChange);
        this.addEventListener('shopify:block:select', (e) => {
          const item = e.target.closest('[data-acc]');
          if (item && this.mq.matches) this.toggle(item, true);
        });
        this.sync();
      }

      disconnectedCallback() {
        if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onChange);
        else if (this.mq.removeListener) this.mq.removeListener(this.onChange);
      }

      toggle(item, open) {
        item.classList.toggle('is-open', open);
        const btn = item.querySelector('[data-acc-btn]');
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      sync() {
        const mobile = this.mq.matches;
        this.items.forEach((item) => {
          const btn = item.querySelector('[data-acc-btn]');
          if (!btn) return;
          if (mobile) {
            btn.removeAttribute('tabindex');
            btn.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
          } else {
            btn.setAttribute('tabindex', '-1');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mq-journal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mq-journal')) {
    customElements.define('mq-journal', class MqJournal extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('.mq-jr__tab'));
        this.cards = Array.from(this.querySelectorAll('.mq-jr__card'));
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.filter(tab)));
      }

      filter(tab) {
        const kind = tab.dataset.filter;
        this.tabs.forEach((t) => t.setAttribute('aria-pressed', t === tab ? 'true' : 'false'));
        let first = true;
        this.cards.forEach((card) => {
          const show = kind === 'all' || card.dataset.kind === kind;
          card.hidden = !show;
          card.classList.remove('mq-jr__card--lead');
          if (show && first) { card.classList.add('mq-jr__card--lead'); first = false; }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mq-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mq-marquee')) {
    customElements.define('mq-marquee', class MqMarquee extends HTMLElement {
      connectedCallback() {
        this.group = this.querySelector('.mq-marquee__group');
        this.speed = parseFloat(this.dataset.speed) || 60;
        this.update = this.update.bind(this);
        this.update();
        if ('ResizeObserver' in window && this.group) {
          this.observer = new ResizeObserver(this.update);
          this.observer.observe(this.group);
        }
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.update);
        this.addEventListener('shopify:block:select', () => this.classList.add('is-paused'));
        this.addEventListener('shopify:block:deselect', () => this.classList.remove('is-paused'));
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
      update() {
        if (!this.group) return;
        const width = this.group.offsetWidth;
        if (!width) return;
        this.style.setProperty('--mq-duration', (width / this.speed).toFixed(2) + 's');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mq-product-arc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mq-product-arc')) {
    customElements.define('mq-product-arc', class MqProductArc extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this.stage = this.querySelector('[data-arc-stage]');
        this.track = this.querySelector('[data-arc-track]');
        if (!this.stage || !this.track) return;
        this.originals = Array.from(this.track.querySelectorAll('.mq-arc__item'));
        this.count = this.originals.length;
        if (!this.count) return;
        this._ready = true;

        this.items = this.originals.slice();
        this.dial = this.querySelector('[data-arc-dial]');
        this.info = this.querySelector('[data-arc-info]');
        this.bignum = this.querySelector('[data-arc-bignum]');
        this.form = this.querySelector('[data-arc-form]');
        const addLabel = this.querySelector('[data-arc-add-label]');
        this.addLabel = addLabel ? addLabel.textContent : 'Add to cart';

        const d = this.dataset;
        this.cfg = {
          autoplay: d.autoplay || 'none',
          speed: parseFloat(d.speed) || 6,
          interval: (parseFloat(d.interval) || 4) * 1000,
          tilt: d.tilt === 'true',
          spacing: (parseFloat(d.spacing) || 120) / 100,
          arc: (parseFloat(d.arc) || 90) / 100
        };
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.reduced && this.cfg.autoplay === 'drift') this.cfg.autoplay = 'none';

        this.pos = 0;
        this.target = 0;
        this.vel = 0;
        this.mode = 'idle';
        this.active = -1;
        this.visible = true;
        this.hover = false;
        this.pauseUntil = 0;
        this.raf = null;
        this.last = 0;
        this.dirty = true;

        const total = this.querySelector('[data-arc-total]');
        if (total) total.textContent = this.pad(this.count);

        ['onDown', 'onMove', 'onUp', 'onClick', 'onWheel', 'onKey', 'onSubmit', 'tick'].forEach((fn) => { this[fn] = this[fn].bind(this); });
        this.stage.addEventListener('pointerdown', this.onDown);
        this.stage.addEventListener('pointermove', this.onMove);
        this.stage.addEventListener('pointerup', this.onUp);
        this.stage.addEventListener('pointercancel', this.onUp);
        this.stage.addEventListener('click', this.onClick, true);
        this.stage.addEventListener('wheel', this.onWheel, { passive: false });
        this.stage.addEventListener('keydown', this.onKey);
        this.stage.addEventListener('dragstart', (e) => e.preventDefault());
        this.stage.addEventListener('focusin', (e) => {
          const item = e.target.closest('.mq-arc__item');
          if (item && !item.classList.contains('is-active')) this.goToItem(item);
        });
        this.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse') return;
          this.hover = true;
          if (this.mode === 'drift') { this.snapNearest(); this.kick(); }
        });
        this.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') this.hover = false; });
        this.addEventListener('pointerdown', (e) => {
          if (this.stage.contains(e.target)) return;
          this.interact();
          if (this.mode === 'drift') { this.snapNearest(); this.kick(); }
        });
        const prev = this.querySelector('[data-arc-prev]');
        const next = this.querySelector('[data-arc-next]');
        if (prev) prev.addEventListener('click', () => this.step(-1));
        if (next) next.addEventListener('click', () => this.step(1));
        if (this.form) this.form.addEventListener('submit', this.onSubmit);

        this.onVis = () => this.kick();
        document.addEventListener('visibilitychange', this.onVis);
        this.ro = new ResizeObserver(() => { this.layout(); this.dirty = true; this.kick(); });
        this.ro.observe(this.stage);
        this.io = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.kick();
        }, { threshold: 0.05 });
        this.io.observe(this);
        if (this.cfg.autoplay === 'step') this.timer = setInterval(() => this.autoStep(), this.cfg.interval);

        this.layout();
        this.render();
        this.kick();
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        if (this.io) this.io.disconnect();
        if (this.timer) clearInterval(this.timer);
        if (this.raf) cancelAnimationFrame(this.raf);
        if (this.onVis) document.removeEventListener('visibilitychange', this.onVis);
        this.raf = null;
      }

      pad(n) { return String(n).padStart(2, '0'); }

      layout() {
        const W = this.stage.clientWidth;
        if (!W) return;
        const desk = window.matchMedia('(min-width: 750px)').matches;
        const cs = getComputedStyle(this);
        const cw = parseFloat(cs.getPropertyValue('--arc-card-w')) || 160;
        const ratio = parseFloat(cs.getPropertyValue('--arc-ratio')) || 1.3333;
        const ch = cw * ratio;
        let R = desk ? Math.min((W * this.cfg.arc) / 2, 680) : W * 0.74;
        R = Math.max(R, cw * 1.9);
        const ring = R + ch / 2 + 22;
        const H = ring + (desk ? 34 : 22);
        const core = Math.max(R - ch / 2 - 26, 60);
        const stepRad = (cw * this.cfg.spacing) / R;
        this.g = { W, R, cw, ch, cx: W / 2, cy: H, step: (stepRad * 180) / Math.PI, px: cw * this.cfg.spacing };

        const s = this.stage.style;
        s.setProperty('--arc-h', H + 'px');
        s.setProperty('--arc-dial', ring * 2 + 'px');
        s.setProperty('--arc-orbit', R * 2 + 'px');
        s.setProperty('--arc-core', core * 2 + 'px');
        s.setProperty('--arc-pin-top', H - ring + 9 + 'px');
        s.setProperty('--arc-glow-top', H - R + 'px');
        if (desk) {
          const panelH = 212;
          s.setProperty('--arc-num-bottom', panelH + 4 + 'px');
          s.setProperty('--arc-num-size', Math.max(64, Math.min(170, (core - panelH) * 1.05)) + 'px');
        } else {
          s.setProperty('--arc-num-bottom', '6px');
          s.setProperty('--arc-num-size', Math.max(56, Math.min(112, core * 0.7)) + 'px');
        }

        const need = Math.ceil(300 / this.g.step);
        while (this.items.length < need) {
          this.originals.forEach((o) => {
            const c = o.cloneNode(true);
            c.classList.add('is-clone');
            c.classList.remove('is-active');
            c.setAttribute('aria-hidden', 'true');
            c.querySelectorAll('a, button, input').forEach((el) => el.setAttribute('tabindex', '-1'));
            c.style.visibility = 'hidden';
            c._v = false;
            this.track.appendChild(c);
            this.items.push(c);
          });
        }
      }

      render() {
        const g = this.g;
        if (!g) return;
        const total = this.items.length;
        let best = null;
        let bestAbs = Infinity;
        for (let i = 0; i < total; i++) {
          const el = this.items[i];
          let d = (i - this.pos) % total;
          if (d < 0) d += total;
          if (d >= total / 2) d -= total;
          const a = d * g.step;
          const abs = Math.abs(a);
          if (abs > 98) {
            if (el._v !== false) { el.style.visibility = 'hidden'; el._v = false; }
            continue;
          }
          if (el._v !== true) { el.style.visibility = 'visible'; el._v = true; }
          const r = (a * Math.PI) / 180;
          const x = g.cx + g.R * Math.sin(r) - g.cw / 2;
          const y = g.cy - g.R * Math.cos(r) - g.ch / 2;
          const t = Math.min(abs / 90, 1);
          const sc = 1 - 0.4 * Math.pow(t, 1.1);
          const op = abs < 58 ? 1 : Math.max(0, 1 - (abs - 58) / 36);
          const rot = this.cfg.tilt ? a : 0;
          el.style.transform = 'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0) rotate(' + rot.toFixed(2) + 'deg) scale(' + sc.toFixed(4) + ')';
          el.style.opacity = op.toFixed(3);
          el.style.zIndex = String(500 - Math.round(abs * 4));
          if (abs < bestAbs) { bestAbs = abs; best = el; }
        }
        const lock = bestAbs < g.step * 0.5;
        for (let i = 0; i < total; i++) {
          const el = this.items[i];
          const on = lock && el === best;
          if (el._a !== on) { el.classList.toggle('is-active', on); el._a = on; }
        }
        if (this.dial) this.dial.style.transform = 'translate(-50%, 50%) rotate(' + (-this.pos * g.step).toFixed(3) + 'deg)';
        if (best) {
          const idx = parseInt(best.dataset.index, 10);
          if (idx !== this.active) this.setActive(idx);
        }
      }

      swap(el) {
        if (!el) return;
        el.classList.remove('is-swap');
        void el.offsetWidth;
        el.classList.add('is-swap');
      }

      setActive(idx) {
        this.active = idx;
        const src = this.originals[idx];
        if (!src) return;
        const d = src.dataset;
        const q = (sel) => this.querySelector(sel);
        const idxEl = q('[data-arc-idx]');
        if (idxEl) idxEl.textContent = this.pad(idx + 1);
        const link = q('[data-arc-link]');
        if (link) { link.textContent = d.title; link.href = d.url; }
        const price = q('[data-arc-price]');
        if (price) price.textContent = d.price;
        const cmp = q('[data-arc-compare]');
        if (cmp) { cmp.textContent = d.compare || ''; cmp.hidden = !d.compare; }
        const save = q('[data-arc-save]');
        if (save) { const pct = parseInt(d.save, 10) || 0; save.hidden = pct <= 0; save.textContent = pct + '% off'; }
        const view = q('[data-arc-view]');
        if (view) view.href = d.url;
        this.swap(this.info);
        if (this.bignum) { this.bignum.textContent = this.pad(idx + 1); this.swap(this.bignum); }
        if (this.form) {
          const v = q('[data-arc-variant]');
          const btn = q('[data-arc-add]');
          const label = q('[data-arc-add-label]');
          const available = d.available === 'true';
          const simple = d.simple === 'true';
          if (v) v.value = d.variant;
          if (btn) { btn.disabled = !available; btn.classList.remove('is-added', 'is-loading'); btn.removeAttribute('aria-busy'); }
          if (label) label.textContent = !available ? 'Sold out' : simple ? this.addLabel : 'Choose options';
        }
        const err = q('[data-arc-error]');
        if (err) { err.hidden = true; err.textContent = ''; }
      }

      kick() {
        if (!this.raf) this.raf = requestAnimationFrame(this.tick);
      }

      interact() {
        this.pauseUntil = performance.now() + 4500;
      }

      snapNearest() {
        this.target = Math.round(this.pos);
        this.mode = 'snap';
      }

      step(dir) {
        this.interact();
        const base = this.mode === 'snap' ? this.target : Math.round(this.pos);
        this.target = base + dir;
        this.mode = 'snap';
        this.kick();
      }

      goToItem(item) {
        const i = this.items.indexOf(item);
        if (i < 0) return;
        const total = this.items.length;
        let d = (i - this.pos) % total;
        if (d < 0) d += total;
        if (d >= total / 2) d -= total;
        this.interact();
        this.target = Math.round(this.pos + d);
        this.mode = 'snap';
        this.kick();
      }

      autoStep() {
        if (!this.visible || this.hover || document.hidden) return;
        if (performance.now() < this.pauseUntil) return;
        if (this.mode === 'drag' || this.mode === 'momentum' || this.mode === 'wheel') return;
        const base = this.mode === 'snap' ? this.target : Math.round(this.pos);
        this.target = base + 1;
        this.mode = 'snap';
        this.kick();
      }

      tick(now) {
        this.raf = null;
        if (!this.g) return;
        if (!this.last) this.last = now;
        const dt = Math.min(now - this.last, 64) / 16.667;
        this.last = now;
        let moving = false;
        switch (this.mode) {
          case 'momentum':
            this.pos += this.vel * dt;
            this.vel *= Math.pow(0.935, dt);
            if (Math.abs(this.vel) < 0.01) { this.target = Math.round(this.pos + this.vel * 6); this.mode = 'snap'; }
            moving = true;
            break;
          case 'snap': {
            const diff = this.target - this.pos;
            if (Math.abs(diff) < 0.001) { this.pos = this.target; this.mode = 'idle'; }
            else this.pos += diff * (1 - Math.pow(0.82, dt));
            moving = true;
            break;
          }
          case 'drift':
            if (this.hover || now < this.pauseUntil) this.snapNearest();
            else this.pos += (this.cfg.speed / this.g.step / 60) * dt;
            moving = true;
            break;
          case 'drag':
          case 'wheel':
            break;
          default:
            if (this.cfg.autoplay === 'drift' && !this.hover && now >= this.pauseUntil && this.visible && !document.hidden) {
              this.mode = 'drift';
              moving = true;
            }
        }
        if (moving || this.dirty) { this.render(); this.dirty = false; }
        const alive = this.visible && !document.hidden && (this.mode !== 'idle' || this.cfg.autoplay === 'drift');
        if (alive) this.raf = requestAnimationFrame(this.tick);
        else this.last = 0;
      }

      onDown(e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        this.drag = { id: e.pointerId, x: e.clientX, y: e.clientY, start: this.pos, lx: e.clientX, lt: e.timeStamp, moved: false };
        this.vel = 0;
      }

      onMove(e) {
        const dr = this.drag;
        if (!dr || e.pointerId !== dr.id || !this.g) return;
        if (!dr.moved) {
          const dx = e.clientX - dr.x;
          const dy = e.clientY - dr.y;
          if (Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) {
            dr.moved = true;
            dr.x = e.clientX;
            dr.lx = e.clientX;
            dr.lt = e.timeStamp;
            dr.start = this.pos;
            this.mode = 'drag';
            this.interact();
            try { this.stage.setPointerCapture(dr.id); } catch (err) {}
            this.stage.classList.add('is-dragging');
          } else if (Math.abs(dy) > 10) {
            this.drag = null;
            return;
          } else {
            return;
          }
        }
        this.pos = dr.start - (e.clientX - dr.x) / this.g.px;
        const frames = Math.max(e.timeStamp - dr.lt, 1) / 16.667;
        const v = -(e.clientX - dr.lx) / this.g.px / frames;
        this.vel = this.vel * 0.6 + v * 0.4;
        dr.lx = e.clientX;
        dr.lt = e.timeStamp;
        this.dirty = true;
        this.kick();
      }

      onUp(e) {
        const dr = this.drag;
        if (!dr || e.pointerId !== dr.id) return;
        this.drag = null;
        if (!dr.moved) return;
        this.stage.classList.remove('is-dragging');
        try { this.stage.releasePointerCapture(dr.id); } catch (err) {}
        if (e.timeStamp - dr.lt > 90) this.vel = 0;
        this.vel = Math.max(-0.5, Math.min(0.5, this.vel));
        if (Math.abs(this.vel) > 0.02) this.mode = 'momentum';
        else this.snapNearest();
        this.suppress = true;
        setTimeout(() => { this.suppress = false; }, 80);
        this.interact();
        this.kick();
      }

      onClick(e) {
        if (this.suppress) { e.preventDefault(); e.stopPropagation(); return; }
        const item = e.target.closest('.mq-arc__item');
        if (!item) return;
        if (!item.classList.contains('is-active')) { e.preventDefault(); this.goToItem(item); }
      }

      onWheel(e) {
        if (!this.g) return;
        const ax = Math.abs(e.deltaX);
        const ay = Math.abs(e.deltaY);
        let dx = 0;
        if (ax > ay) dx = e.deltaX;
        else if (e.shiftKey) dx = e.deltaY;
        if (!dx) return;
        e.preventDefault();
        if (e.deltaMode === 1) dx *= 16;
        this.interact();
        this.mode = 'wheel';
        this.pos += dx / this.g.px;
        this.dirty = true;
        this.kick();
        clearTimeout(this.wheelT);
        this.wheelT = setTimeout(() => { this.snapNearest(); this.kick(); }, 160);
      }

      onKey(e) {
        if (e.target !== this.stage) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1); }
      }

      onSubmit(e) {
        e.preventDefault();
        const btn = this.querySelector('[data-arc-add]');
        const src = this.originals[this.active];
        if (!btn || !src) return;
        if (src.dataset.simple !== 'true') { window.location.href = src.dataset.url; return; }
        if (btn.disabled || btn.classList.contains('is-loading')) return;
        const err = this.querySelector('[data-arc-error]');
        if (err) { err.hidden = true; err.textContent = ''; }
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const fd = new FormData(this.form);
        if (cart && typeof cart.getSectionsToRender === 'function') {
          fd.append('sections', cart.getSectionsToRender().map((s) => s.id));
          fd.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
        }
        const label = this.querySelector('[data-arc-add-label]');
        btn.classList.remove('is-added');
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        this.pauseUntil = performance.now() + 8000;
        const url = (window.routes && window.routes.cart_add_url) || '/cart/add';
        fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
          .then((res) => res.json())
          .then((data) => {
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-busy');
            if (data.status) {
              if (err) { err.textContent = data.description || data.message || 'This item could not be added to your cart.'; err.hidden = false; }
              return;
            }
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(data);
              cart.classList.remove('is-empty');
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
              return;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mq-product-arc', productVariantId: fd.get('id'), cartData: data });
            }
            btn.classList.add('is-added');
            if (label) label.textContent = 'Added';
            clearTimeout(this.addT);
            this.addT = setTimeout(() => {
              btn.classList.remove('is-added');
              if (label) label.textContent = this.addLabel;
            }, 2000);
          })
          .catch(() => {
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-busy');
            this.form.submit();
          });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mq-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mq-product-grid')) {
    customElements.define('mq-product-grid', class MqProductGrid extends HTMLElement {
      connectedCallback() {
        this.onSubmit = this.onSubmit.bind(this);
        this.addEventListener('submit', this.onSubmit);
      }

      disconnectedCallback() {
        this.removeEventListener('submit', this.onSubmit);
      }

      onSubmit(event) {
        const form = event.target.closest('[data-quick-add]');
        if (!form) return;
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        if (!button || button.classList.contains('is-loading')) return;

        const card = form.closest('.mq-pc');
        const error = card ? card.querySelector('.mq-pc__error') : null;
        if (error) { error.hidden = true; error.textContent = ''; }

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const formData = new FormData(form);
        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append('sections', cart.getSectionsToRender().map((s) => s.id));
          formData.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
        }

        const label = button.querySelector('[data-label]');
        const original = label ? label.textContent : '';
        button.classList.remove('is-added');
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');

        const url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
        fetch(url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: formData
        })
          .then((res) => res.json())
          .then((data) => {
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
            if (data.status) {
              if (error) { error.textContent = data.description || data.message || 'Could not add this item to your cart.'; error.hidden = false; }
              return;
            }
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(data);
              if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            } else {
              window.location.href = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
              return;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mq-product-grid', productVariantId: formData.get('id'), cartData: data });
            }
            button.classList.add('is-added');
            if (label) label.textContent = 'Added';
            clearTimeout(button._mqTimer);
            button._mqTimer = setTimeout(() => {
              button.classList.remove('is-added');
              if (label) label.textContent = original;
            }, 2000);
          })
          .catch(() => {
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
            form.submit();
          });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mq-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mq-slider')) {
    customElements.define('mq-slider', class MqSlider extends HTMLElement {
      static trackHeader() {
        const header = document.querySelector('.section-header');
        if (!header) return;
        const set = () => document.documentElement.style.setProperty('--mq-header-h', header.offsetHeight + 'px');
        set();
        if (MqSlider.headerObserved === header) return;
        MqSlider.headerObserved = header;
        if ('ResizeObserver' in window) new ResizeObserver(set).observe(header);
        window.addEventListener('load', set);
      }

      // '2026-10-12 00:00' -> epoch ms (store time zone; offset comes from window.mqStoreTz, set inline by Liquid). Empty or malformed value 0 = no limit.
      // If no time is given, start counts as 00:00 and end as 23:59.
      static ts(value, isEnd) {
        if (!value) return 0;
        const m = String(value).trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
        if (!m) return 0;
        const pad = (n) => ('0' + n).slice(-2);
        const hh = m[4] != null ? pad(m[4]) : (isEnd ? '23' : '00');
        const mm = m[5] != null ? m[5] : (isEnd ? '59' : '00');
        const t = Date.parse(m[1] + '-' + pad(m[2]) + '-' + pad(m[3]) + 'T' + hh + ':' + mm + ':00' + (window.mqStoreTz || '+00:00'));
        if (isNaN(t)) return 0;
        return isEnd ? t + 59999 : t;
      }

      placeUnderHeader() {
        const section = this.closest('.mq-slider-section');
        const wrapper = this.closest('.shopify-section');
        const main = document.getElementById('MainContent');
        if (!section) return;
        const isFirst = main && wrapper && main.firstElementChild === wrapper;
        if (section.dataset.underHeader === 'true' && isFirst) {
          MqSlider.trackHeader();
          section.classList.add('is-under-header');
        } else {
          section.classList.remove('is-under-header');
        }
      }

      connectedCallback() {
        this.placeUnderHeader();
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.sectionEl = this.closest('.mq-slider-section');
        this.design = !!(window.Shopify && window.Shopify.designMode);
        this.all = Array.from(this.track.querySelectorAll('[data-slide]'));
        this.dotsBox = this.querySelector('[data-dots]');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.slides = [];
        this.dots = [];
        this.index = 0;
        this.liveKey = null;
        this.delay = parseInt(this.dataset.speed, 10) || 5000;
        this.autoplay = false;
        this.paused = false;
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.goTo(this.index - 1); this.start(); });
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.goTo(this.index + 1); this.start(); });
        let scrollTimer;
        this.track.addEventListener('scroll', () => { clearTimeout(scrollTimer); scrollTimer = setTimeout(() => this.sync(), 60); }, { passive: true });
        this.addEventListener('mouseenter', () => { this.paused = true; });
        this.addEventListener('mouseleave', () => { this.paused = false; });
        this.addEventListener('focusin', () => { this.paused = true; });
        this.addEventListener('focusout', () => { this.paused = false; });
        this.track.addEventListener('touchstart', () => { this.paused = true; }, { passive: true });
        this.track.addEventListener('touchend', () => { this.paused = false; this.start(); }, { passive: true });
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-slide]');
          const i = this.slides.indexOf(slide);
          if (i > -1) { this.paused = true; this.goTo(i, true); }
        });
        this.addEventListener('shopify:block:deselect', () => { this.paused = false; });
        document.addEventListener('shopify:section:reorder', () => this.placeUnderHeader());
        this.applySchedule();
        // If an offer starts or ends while the page is open, the slides switch on their own.
        this.scheduleTimer = setInterval(() => this.applySchedule(), 30000);
      }

      disconnectedCallback() { clearInterval(this.timer); clearInterval(this.scheduleTimer); }

      applySchedule() {
        let keep = this.all;
        if (!this.design) {
          const now = Date.now();
          const info = this.all.map((el) => {
            const a = MqSlider.ts(el.dataset.start, false);
            const b = MqSlider.ts(el.dataset.end, true);
            return { el: el, end: b, fallback: el.dataset.fallback === 'true', live: !(a && now < a) && !(b && now > b) };
          });
          let live = info.filter((i) => i.live);
          const timed = live.filter((i) => !i.fallback);
          if (timed.length) live = timed;
          if (!live.length) {
            const past = info.filter((i) => i.end && now > i.end).sort((x, y) => y.end - x.end);
            if (past.length) live = [past[0]];
          }
          keep = live.map((i) => i.el);
        }
        const key = keep.map((el) => el.id).join('|');
        if (key === this.liveKey) return;
        this.liveKey = key;
        this.all.forEach((el) => { el.hidden = keep.indexOf(el) === -1; });
        this.slides = keep;
        this.index = 0;
        this.track.scrollTo({ left: 0, behavior: 'auto' });
        if (this.sectionEl && !this.design) this.sectionEl.hidden = keep.length === 0;
        const multi = keep.length > 1;
        if (this.prevBtn) this.prevBtn.hidden = !multi;
        if (this.nextBtn) this.nextBtn.hidden = !multi;
        this.dots = [];
        if (this.dotsBox) {
          this.dotsBox.innerHTML = '';
          this.dotsBox.hidden = !multi;
          if (multi) {
            keep.forEach((el, k) => {
              const li = document.createElement('li');
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.className = 'mq-slider__dot';
              dot.setAttribute('aria-label', 'Go to slide ' + (k + 1));
              if (k === 0) dot.setAttribute('aria-current', 'true');
              dot.addEventListener('click', () => { this.goTo(k); this.start(); });
              li.appendChild(dot);
              this.dotsBox.appendChild(li);
              this.dots.push(dot);
            });
          }
        }
        keep.forEach((el, k) => el.setAttribute('aria-label', (k + 1) + ' / ' + keep.length));
        this.autoplay = this.dataset.autoplay === 'true' && multi;
        clearInterval(this.timer);
        this.start();
      }

      start() {
        clearInterval(this.timer);
        if (!this.autoplay) return;
        this.timer = setInterval(() => { if (!this.paused && !document.hidden) this.goTo(this.index + 1); }, this.delay);
      }

      goTo(i, instant) {
        const n = this.slides.length;
        if (!n) return;
        this.index = (i + n) % n;
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
        this.updateDots();
      }

      sync() {
        const w = this.track.clientWidth;
        if (!w) return;
        const i = Math.round(this.track.scrollLeft / w);
        if (i !== this.index) { this.index = i; this.updateDots(); }
      }

      updateDots() {
        this.dots.forEach((dot, k) => {
          if (k === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mq-stores"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mq-stores')) {
    customElements.define('mq-stores', class MqStores extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('.mq-st__card'));
        this.chips = Array.from(this.querySelectorAll('[data-st-city]'));
        this.input = this.querySelector('[data-st-search]');
        this.none = this.querySelector('[data-st-none]');
        this.city = '';
        this.chips.forEach((chip) => chip.addEventListener('click', () => {
          this.city = chip.dataset.stCity;
          this.chips.forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
          this.apply();
        }));
        if (this.input) this.input.addEventListener('input', () => this.apply());
      }

      norm(s) {
        return (s || '').toLocaleLowerCase('en-US').trim();
      }

      apply() {
        const q = this.norm(this.input ? this.input.value : '');
        const city = this.norm(this.city);
        let visible = 0;
        this.cards.forEach((card) => {
          const okCity = !city || this.norm(card.dataset.city) === city;
          const okQ = !q || this.norm(card.dataset.search).includes(q);
          const show = okCity && okQ;
          card.hidden = !show;
          if (show) visible++;
        });
        if (this.none) this.none.hidden = visible > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mq-ugc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mq-ugc')) {
    customElements.define('mq-ugc', class MqUgc extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.items = Array.from(this.track.querySelectorAll('[data-item]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.autoplay = this.dataset.autoplay === 'true' && this.items.length > 1;
        this.index = -1;
        this.visible = true;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.items.forEach((item, i) => {
          const focus = item.querySelector('[data-focus]');
          if (focus) {
            focus.addEventListener('click', (e) => {
              if (i !== this.index) { e.preventDefault(); this.goTo(i); }
            });
          }
          const mute = item.querySelector('[data-mute]');
          const video = item.querySelector('video');
          if (mute && video) {
            mute.addEventListener('click', (e) => {
              e.stopPropagation();
              video.muted = !video.muted;
              mute.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
              mute.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
              if (!video.muted) this.classList.add('is-paused');
            });
          }
        });

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.dot, 10)));
          const fill = dot.querySelector('.mq-ugc__dot-fill');
          if (fill) {
            fill.addEventListener('animationend', () => {
              if (this.autoplay && dot.getAttribute('aria-current') === 'true') this.goTo((this.index + 1) % this.items.length);
            });
          }
        });

        this.addEventListener('mouseenter', () => this.classList.add('is-paused'));
        this.addEventListener('mouseleave', () => {
          const unmuted = this.querySelector('[data-mute][aria-pressed="true"]');
          if (!unmuted) this.classList.remove('is-paused');
        });
        this.track.addEventListener('pointerdown', () => this.classList.add('is-paused'));
        this.track.addEventListener('touchend', () => { setTimeout(() => this.classList.remove('is-paused'), 1500); }, { passive: true });

        this.addEventListener('shopify:block:select', (e) => {
          const i = this.items.indexOf(e.target.closest('[data-item]'));
          if (i > -1) { this.classList.add('is-paused'); this.goTo(i, true); }
        });
        this.addEventListener('shopify:block:deselect', () => this.classList.remove('is-paused'));

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            this.visible = entries[0].isIntersecting;
            this.classList.toggle('is-offscreen', !this.visible);
            if (!this.visible) this.classList.add('is-paused');
            else if (!this.matches(':hover')) this.classList.remove('is-paused');
            this.syncVideos();
          }, { threshold: 0.25 });
          this.io.observe(this);
        }

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => { if (this.index > -1) this.goTo(this.index, true); });
          this.ro.observe(this.track);
        }

        const start = Math.floor((this.items.length - 1) / 2);
        requestAnimationFrame(() => { this.goTo(start, true); this.update(); });
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
      }

      goTo(i, instant) {
        const item = this.items[i];
        if (!item) return;
        const left = item.offsetLeft + item.offsetWidth / 2 - this.track.clientWidth / 2;
        this.track.scrollTo({ left, behavior: instant || this.reduced ? 'auto' : 'smooth' });
        this.setActive(i);
      }

      update() {
        const center = this.track.scrollLeft + this.track.clientWidth / 2;
        let best = 0;
        let bestD = Infinity;
        this.items.forEach((item, i) => {
          const d = Math.abs(item.offsetLeft + item.offsetWidth / 2 - center);
          if (d < bestD) { bestD = d; best = i; }
        });
        if (best !== this.index) this.setActive(best);
      }

      setActive(i) {
        if (i === this.index) return;
        this.index = i;
        this.items.forEach((item, k) => {
          const dist = Math.abs(k - i);
          item.classList.toggle('is-active', dist === 0);
          item.classList.toggle('is-near', dist === 1);
          item.classList.toggle('is-far', dist >= 2);
        });
        this.dots.forEach((dot, k) => {
          if (k === i) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.syncVideos();
      }

      syncVideos() {
        this.items.forEach((item, k) => {
          const video = item.querySelector('video');
          if (!video) return;
          if (k === this.index && this.visible) {
            const p = video.play();
            if (p && p.catch) p.catch(() => {});
          } else {
            video.pause();
            if (!video.muted) {
              video.muted = true;
              const mute = item.querySelector('[data-mute]');
              if (mute) { mute.setAttribute('aria-pressed', 'false'); mute.setAttribute('aria-label', 'Unmute'); }
            }
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mq-video-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mq-video-banner')) {
    customElements.define('mq-video-banner', class MqVideoBanner extends HTMLElement {
      connectedCallback() {
        this.wraps = Array.from(this.querySelectorAll('.mq-vid__video'));
        this.toggle = this.querySelector('[data-toggle]');
        this.modal = this.querySelector('[data-modal]');
        this.userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.inView = false;

        this.wraps.forEach((wrap) => {
          const video = wrap.querySelector('video');
          if (!video) return;
          video.muted = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          video.addEventListener('playing', () => wrap.classList.add('is-playing'));
        });

        if (this.toggle) {
          this.syncToggle();
          this.toggle.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.syncToggle();
            this.sync();
          });
        }

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            this.inView = entries[0].isIntersecting;
            this.sync();
          }, { threshold: 0.15 });
          this.io.observe(this);
        } else {
          this.inView = true;
          this.sync();
        }

        this.onResize = () => this.sync();
        window.addEventListener('resize', this.onResize);

        if (this.modal) {
          const openBtn = this.querySelector('[data-open-modal]');
          const closeBtn = this.modal.querySelector('[data-close]');
          const fullVideo = this.modal.querySelector('video');
          if (openBtn) openBtn.addEventListener('click', () => this.openModal(fullVideo));
          if (closeBtn) closeBtn.addEventListener('click', () => this.modal.close());
          this.modal.addEventListener('click', (e) => { if (e.target === this.modal) this.modal.close(); });
          this.modal.addEventListener('close', () => {
            if (fullVideo) fullVideo.pause();
            this.modalOpen = false;
            this.sync();
            if (openBtn) openBtn.focus();
          });
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        window.removeEventListener('resize', this.onResize);
      }

      openModal(video) {
        if (!this.modal) return;
        this.modalOpen = true;
        this.sync();
        if (typeof this.modal.showModal === 'function') this.modal.showModal();
        else this.modal.setAttribute('open', '');
        if (video) {
          video.currentTime = 0;
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
        }
      }

      syncToggle() {
        if (!this.toggle) return;
        this.toggle.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
        this.toggle.setAttribute('aria-label', this.userPaused ? 'Play video' : 'Pause video');
      }

      sync() {
        this.wraps.forEach((wrap) => {
          const video = wrap.querySelector('video');
          if (!video) return;
          const visible = wrap.offsetParent !== null || getComputedStyle(wrap).display !== 'none';
          const shouldPlay = visible && this.inView && !this.userPaused && !this.modalOpen && getComputedStyle(wrap).display !== 'none';
          if (shouldPlay) {
            if (video.paused) {
              const p = video.play();
              if (p && p.catch) p.catch(() => {});
            }
          } else if (!video.paused) {
            video.pause();
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
